import React from 'react';
import PropTypes from 'prop-types';

import styles from './CheckBox.scss';

class Checkbox extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			checked: props.checked || props.defaultChecked || false,
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentDidUpdate(prevProps) {
		// Typical usage (don't forget to compare props):
		if (this.props.checked !== prevProps.checked) {
			this.setState(Object.assign({}, this.state, {checked: this.props.checked}));
		}
	}

	handleChange() {
		if (this.props.disabled) {
			return;
		}
		this.setState({
			checked: !this.state.checked,
		}, () => {
			if (this.props.customOnchange !== null) {
				this.props.customOnchange(this.state.checked);
			}
		});

	}

	render() {
		const {disabled} = this.props;
		const {checked} = this.state;
		return (
			<div className={this.props.className}>
				<input
					className={`${styles.container} ${checked ? styles.checked : null}`}
					id={this.props.name}
					type="button"
					data-test="checkbox-button"
					onClick={(e) => {
						e.preventDefault();
						this.handleChange();
					}}/>

				<input
					type="hidden"
					value={checked}
					name={this.props.name}
					className={styles.input}
					disabled={disabled}
					data-test="checkbox-value"/>
			</div>
		);
	}
}

Checkbox.propTypes = {
	name: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	defaultChecked: PropTypes.bool,
	disabled: PropTypes.bool,
	customOnchange: PropTypes.func,
	className: PropTypes.string
};
Checkbox.defaultProps = {
	checked: false,
	customOnchange: null
};
export default Checkbox;